<template>
  <header class="intro-wrapper">
    <VideoComponent />

    <div class="content-wrapper">
      <MainNav @click="id => $emit('click', id)" />

      <div class="footer">
        <div ref="nav" class="links">
          <LinksRules />
        </div>

        <div ref="img" class="img-wrapper">
          <div class="img" />
        </div>

        <div class="links">
          <LinksMedia />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import MainNav from '../modules/MainNav'
import VideoComponent from './Video'
import LinksMedia from '@/components/modules/LinksMedia'
import LinksRules from '@/components/modules/LinksRules'

import gsap from 'gsap'

export default {
  components: {
    MainNav,
    VideoComponent,
    LinksMedia,
    LinksRules
  },
  watch: {
    '$store.getters.isPageLoaded'(value) {
      if (value) {
        const listItems = document.querySelectorAll('.list-item-animation')
        const { img } = this.$refs

        const tl = gsap.timeline()

        tl.to(listItems, {
          y: 0,
          delay: 1,
          duration: 0.5,
          ease: 'power2.easeOut',
          stagger: {
            amount: 0.3
          }
        }).to(img, {
          y: 0,
          duration: 0.5,
          ease: 'back.easeOut'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.intro-wrapper {
  @include hide-down(lg);
  width: 100vw;
  height: $vh;
  padding: 70px 70px 40px;

  @include media-down(xl) {
    padding: 25px 50px 24px;
  }

  // hide scrollbar on edge
  -ms-overflow-style: none;
}

.content-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  position: relative;

  padding-top: 180px;
}

.footer {
  flex-grow: 1;

  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  width: 100%;
  max-height: 270px;
}

.links {
  flex-basis: 40%;
}

.img-wrapper {
  flex-basis: 20%;
  align-self: flex-start;
  position: relative;
  transform: translateY(300px);
}

.img {
  @include fill-space;
  top: 50px;
  height: 360px;
  background-image: url('/images/bottle.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;

  @include media-down(xl) {
    top: 33px;
  }
}
</style>
